// service.js
import { useApiHelper } from '../../utils/helper/apiHelper';

export const useLoginService = () => {
    const { post, loading } = useApiHelper();

// console.log(import.meta.env);

// console.log(import.meta.env.VITE_APP_API_URL);
    const doLogin = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            // throw error;
        }
    };

    return {
        doLogin,
        loading,
    };
};
